import { useQuery } from 'react-query';
import { getCodeById } from 'src/services/api/codes';

function useGetCode(code, params) {
  return useQuery(['code', code, params], (key, code, params) => getCodeById(code, params));
}

export default useGetCode;
